export enum EnergyType {
  Burner = 'burner',
  Electric = 'electric',
}
